import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import './globals.css';
// F3: registers window.__feedLatency() / window.__pushLatency() (the
// feed→screen and relay-push probes). Side-effect import only — the stamps
// live in marketStore / relayPush; nothing is spent until a live view
// registers tickers.
import './lib/trading/feedLatencyProbe';

// speed-demon T-A3: the default Resource Timing ring (250 entries) overflows
// in minutes under the feed's fetch churn, evicting the order POST entries the
// latency probe cross-references. Widen it at boot; feature-detected so a
// non-supporting runtime is a no-op.
if (
  typeof performance !== 'undefined' &&
  typeof performance.setResourceTimingBufferSize === 'function'
) {
  performance.setResourceTimingBufferSize(500);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
